import ApiService, { callCustomMethodAsync } from '../service/ApiService';

let moduleApi = {};
let moduleName = "role_feature";

moduleApi.create = async (dataForm,loading) => {
 let api = {
    module: moduleName,
    type: "create",
    value: dataForm,
    dontLoading: (loading == undefined ? false : loading ),
    message: {
      success: "hidden"
    }
  };

  const result = await ApiService(api);
  mushroom[moduleName].invalidCache();
  return result;
};

moduleApi.createMany = async (dataForm) => {
 let api = {
    module: moduleName,
    type: "batchCreate",
    value: dataForm,
    message: {
      success: "hidden",
      error: "hidden"
    }
  };

  const result = await ApiService(api);
  mushroom[moduleName].invalidCache();
  return result;
};

moduleApi.update = async (dataForm,loading) => {
  let api = {
    module: moduleName,
    type: "partialUpdate",
    value: dataForm,
    dontLoading: (loading == undefined ? false : loading ),
    message: {
      success: "hidden"
    }
  };

  const result = await ApiService(api);
  mushroom[moduleName].invalidCache();
  return result;
};

moduleApi.list = async (dataFilter,loading) => {
  let api = {
    module: moduleName,
    dontLoading: (loading == undefined ? false : loading ),
    type: "list",
    value: dataFilter
  };

  const result = await ApiService(api);
  mushroom[moduleName].invalidCache();
  return result;
};

moduleApi.delete = async (id) => {
  let api = {
    module: moduleName,
    type: "delete",
    value: {id: id}
  };

  const result = await ApiService(api);
  mushroom[moduleName].invalidCache();
  return result;
};

moduleApi.findById = async (id) => {
  let api = {
    module: moduleName,
    type: "findById",
    value: {id: id}
  };

  const result = await ApiService(api);
  mushroom[moduleName].invalidCache();
  return result;
};

moduleApi.SaveCheckAllOption = async (id) => {
  let api = {
    module: moduleName,
    body: {
      role_id: id
    },
    type: "SaveCheckAllOption",
    message: {
      success: "hidden",
      error: "hidden"
    }
  };
  const result = await callCustomMethodAsync(api);
  mushroom[moduleName].invalidCache();
  return result;
};

moduleApi.SaveUnCheckAllOption = async (id) => {
  let api = {
    module: moduleName,
    body: {
      role_id: id
    },
    type: "SaveUnCheckAllOption",
    message: {
      success: "hidden",
      error: "hidden"
    }
  };
  const result = await callCustomMethodAsync(api);
  mushroom[moduleName].invalidCache();
  return result;
};

moduleApi.ResetDefaultOption = async (data) => {
  let api = {
    module: moduleName,
    body: data,
    type: "ResetDefaultOption",
    message: {
      success: "hidden",
      error: "hidden"
    }
  };
  const result = await callCustomMethodAsync(api);
  mushroom[moduleName].invalidCache();
  return result;
};

export default moduleApi;
